import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SecuredBaseComponent } from '../base/secured-base.component';
import { ManagerService } from '../services/manager.service';

@Component({
  selector: 'dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.css']
})
export class DashboardComponent extends SecuredBaseComponent {

  constructor(public override snackBar: MatSnackBar, public override router: Router, public override managerService: ManagerService)
  {
    super(snackBar, router, managerService);
  }

  override ngOnInit() {
    super.ngOnInit();
  }
}
